import { useQuery } from "@tanstack/react-query";
import { IApiPagination } from "../../../interfaces/IPagination";
import distributorTypeApi from "../services/distributorType.api";
import { TDistributorTypeFilter } from "../types/distributorTypes.types";

export type UseDistributorTypeQueryParams = {
  filter: TDistributorTypeFilter;
  pagination: IApiPagination;
};

export const useDistributorTypeQuery = (
  params: UseDistributorTypeQueryParams,
) => {
  return useQuery({
    queryKey: ["distributor-types", params],
    queryFn: async () => {
      const res = await distributorTypeApi.getDistributorTypes(
        params.filter,
        params.pagination,
      );
      return res.data;
    },
    staleTime: 1000 * 60,
  });
};
